var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpenBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8.50002C9.17305 8.50002 8.50005 7.82702 8.50005 7.00002C8.50005 6.17302 9.17305 5.50002 10 5.50002C10.827 5.50002 11.5 6.17302 11.5 7.00002C11.5 7.82702 10.827 8.50002 10 8.50002ZM10 3.50002C8.07005 3.50002 6.50005 5.07002 6.50005 7.00002C6.50005 8.93002 8.07005 10.5 10 10.5C11.93 10.5 13.5 8.93002 13.5 7.00002C13.5 5.07002 11.93 3.50002 10 3.50002ZM10.2197 11.9976C5.91375 12.0976 3.10475 8.41462 2.17275 6.99562C3.19875 5.39062 5.78275 2.10462 9.78075 2.00262C14.0697 1.89362 16.8948 5.58562 17.8267 7.00462C16.8018 8.60962 14.2168 11.8956 10.2197 11.9976ZM19.8678 6.50262C19.2297 5.39062 15.7057 -0.183379 9.72975 0.00362058C4.20175 0.143621 0.98675 5.01362 0.13275 6.50262C-0.04425 6.81062 -0.04425 7.18962 0.13275 7.49762C0.76175 8.59462 4.16175 13.9996 10.0247 13.9996C10.1067 13.9996 10.1888 13.9986 10.2708 13.9966C15.7977 13.8556 19.0138 8.98662 19.8678 7.49762C20.0438 7.18962 20.0438 6.81062 19.8678 6.50262Z",
    fill: "#151A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpenBlack);
export default __webpack_public_path__ + "static/media/eye-open-black.f142ca7387e52d723f9f587eb9a4eed6.svg";
export { ForwardRef as ReactComponent };